const TestimonialSchema = {
  title: 'Testimonial',
  fieldsets: [
    {
      id: 'default',
      title: 'Testimonial',
      fields: ['quote', 'person', 'iconColor', 'backgroundColor', 'textColor'],
    },
  ],
  properties: {
    quote: {
      title: 'Quote',
      type: 'string',
      widget: 'textarea',
      rows: 4,
    },
    person: {
      title: 'Person/Entity',
      type: 'string',
      description: 'Name of person or organization',
    },
    iconColor: {
      title: 'Icon Color',
        choices: [
        ['#f8f9fa', 'White'],
        ['#8bc1b4', 'Light Green'],
      ],
      default: '#f8f9fa',
    },
    backgroundColor: {
      title: 'Background Color',
      type: 'string',
      choices: [
        ['#be1e2d', 'Red'],
        ['#8bc1b4', 'Light Green'],
        ['#163d4c', 'Teal'],
        ['#2c3437', 'Blue-Grey'],
        ['#f8f9fa', 'White'],
      ],
      default: '#163d4c',
    },
    textColor: {
      title: 'Text Color',
        choices: [
        ['#f8f9fa', 'White'],
        ['#000000DE', 'Black'],
      ],
      default: '#f8f9fa',
    },
  },
  required: ['quote'],
};

export default TestimonialSchema;